import { ENV } from 'config/env';

export const createApiBaseUrl = (): string => ENV.BASE_URL;
